<div fwMenuCloseTriggers>

  <!-- Bookmarks -->
  <fw-icon-button
    [cdkMenuTriggerFor]="bookmarksMenu"
    icon="bookmark"
    test-id="topbar-bookmarks">
  </fw-icon-button>
  <ng-template #bookmarksMenu>
    <fw-menu-container shadow="large" width="280px" offset="10px">
      <fw-menu-item
        *ngFor="let bookmark of bookmarks$ | async"
        [title]="bookmark.label"
        [href]="bookmark.url"
        size="compact"
        target="_blank"
        attr.test-id="topbar-bookmrarks-{{bookmark.label}}"
      >
        <fw-icon>open</fw-icon>
      </fw-menu-item>
      <fw-menu-item *ngIf="(bookmarks$ | async)?.length === 0">
        <p>{{ 'topBar.bookmarks.noBookmarks' | translate }}</p>
      </fw-menu-item>
      <fw-menu-separator></fw-menu-separator>
      <fw-menu-item
        icon="edit"
        [title]="'topBar.bookmarks.edit' | translate"
        test-id="topbar-bookmarks-edit"
        (click)="editBookmarks()">
      </fw-menu-item>
    </fw-menu-container>
  </ng-template>

  <!-- Info -->
  <fw-icon-button [cdkMenuTriggerFor]="infoMenu" icon="question-circle"></fw-icon-button>
  <ng-template #infoMenu>
    <fw-menu-container shadow="large" width="280px" offset="10px">
      <fw-menu-item
        icon="notebook-pen-edit"
        href="https://docs.flywheel.io/?q=release"
        target="_blank"
        [title]="'topBar.helpMenu.releaseNotes' | translate"
        test-id="topbar-help-release"
        size="compact">
      </fw-menu-item>
      <fw-menu-item
        icon="files"
        href="https://docs.flywheel.io/"
        target="_blank"
        [title]="'topBar.helpMenu.browseDocs' | translate"
        test-id="topbar-help-docs"
        size="compact">
      </fw-menu-item>
      <fw-menu-item
        icon="message-chat-question-support"
        href="https://forum.flywheel.io/login"
        target="_blank"
        [title]="'topBar.helpMenu.forum' | translate"
        test-id="topbar-help-forum"
        size="compact">
      </fw-menu-item>
      <fw-menu-item
        icon="message-question-checkmark"
        href="https://support.flywheel.io/hc/en-us/requests/new"
        target="_blank"
        [title]="'topBar.helpMenu.support' | translate"
        test-id="topbar-help-feedback"
        size="compact">
      </fw-menu-item>
      <fw-menu-separator></fw-menu-separator>
      <fw-menu-item
        [title]="'topBar.helpMenu.flywheelCore' | translate"
        [description]="version$ | async">
      </fw-menu-item>
    </fw-menu-container>
  </ng-template>

  <!-- Profile -->
  <div
    class="avatar-container"
    [ngClass]="{'admin-mode': (exhaustiveMode$ | async), 'show-tenant': centralEnabled }"
    [cdkMenuTriggerFor]="profileMenu"
    test-id="topbar-profile-menu"
  >
    <fw-chip
      *ngIf="centralEnabled"
      [color]="(exhaustiveMode$ | async) ? 'secondary' : 'primary'"
      [title]="(currentTenant$ | async)?.label"
      [selectable]="false"
    ></fw-chip>
    <fw-avatar
      *ngIf="profile$ | async"
      [appUser]="profile$ | async"
      size="medium"
    >
    </fw-avatar>
    <fw-icon *ngIf="exhaustiveMode$ | async">crown-style-circle</fw-icon>
  </div>
  <ng-template #profileMenu>
    <fw-menu-container shadow="large" width="300px" offset="10px">
      <div class="profile-display">
        <fw-avatar
          size="medium"
          [appUser]="profile$ | async"
        ></fw-avatar>
        <h4>{{ (profile$ | async).firstname }} {{  (profile$ | async).lastname }}</h4>
        <p>{{ (profile$ | async).email }}</p>
        <ng-template [ngIf]="centralEnabled">
          <p>{{ (org$ | async)?.name }}</p>
          <fw-chip [selectable]="false" color="primary" [title]="(currentTenant$ | async)?.label"></fw-chip>
        </ng-template>
      </div>
      <fw-menu class="profile-menu">
        <fw-menu-separator></fw-menu-separator>
        <ng-container *ngIf="isSiteAdmin">
          <fw-menu-item
            [ngClass]="{ 'manage-mode-on': exhaustiveMode$ | async }"
            class="purple-icon manage-mode-on"
            (click)="toggleExhaustiveMode()"
            test-id="topbar-profile-manage"
            icon="crown-style-circle"
            iconColor="secondary"
            [title]="'topBar.profileMenu.manageSite' | translate"
            size="compact"
          >
            <p class="manage-site-status">{{ (exhaustiveMode$ | async) ? ('topBar.profileMenu.on' | translate) : ('topBar.profileMenu.off' | translate) }}</p>
          </fw-menu-item>
          <fw-menu-separator></fw-menu-separator>
        </ng-container>
        <fw-menu-item
          class="blue-icon"
          test-id="topbar-profile-profile"
          href="#/profile"
          icon="user"
          [title]="'topBar.profileMenu.profile' | translate"
          size="compact">
        </fw-menu-item>
        <ng-template [ngIf]="centralEnabled">
          <fw-menu-item
            class="blue-icon"
            [href]="centralHomeUrl"
            icon="home-modern-door"
            [title]="'topBar.profileMenu.flywheelHome' | translate"
            test-id="topbar-profile-central"
            size="compact">
          </fw-menu-item>
          <fw-menu-separator></fw-menu-separator>
          <fw-menu-item><p>{{ 'topBar.profileMenu.otherTenants' | translate }}</p></fw-menu-item>
          <fw-menu-item
            *ngFor="let tenant of tenants$ | async"
            [title]="tenant.label"
            href="https://{{tenant.tenant_url}}"
            [target]="tenant.path"
            attr.test-id="topbar-tenant-{{tenant.label}}"
          >
            <fw-icon>open</fw-icon>
          </fw-menu-item>
          <fw-menu-separator></fw-menu-separator>
        </ng-template>
        <fw-menu-item
          (click)="logout()"
          class="blue-icon"
          test-id="topbar-profile-logout"
          icon="logout"
          [title]="'topBar.profileMenu.logout' | translate"
          size="compact">
        </fw-menu-item>
      </fw-menu>
    </fw-menu-container>
  </ng-template>
</div>
